export default class GeoAction {
    static GEO_REGIONS_REQUEST = 'GEO_REGIONS_REQUEST';
    static GEO_REGIONS_SUCCESS = 'GEO_REGIONS_SUCCESS';
    static GEO_REGIONS_FAILED = 'GEO_REGIONS_FAILED';



    static geoRegions_Request() {
        return {
            type: this.GEO_REGIONS_REQUEST
        }
    }

    static geoRegions_Success(data) {
        return {
            type: this.GEO_REGIONS_SUCCESS,
            data
        }
    }

    static geoRegions_Failed(error) {
        return {
            type: this.GEO_REGIONS_FAILED,
            error
        }
    }


    // GEO AREAS

    static GEO_AREAS_REQUEST = 'GEO_AREAS_REQUEST';
    static GEO_AREAS_SUCCESS = 'GEO_AREAS_SUCCESS';
    static GEO_AREAS_FAILED = 'GEO_AREAS_FAILED';

    static geoAreas_Request() {
        return {
            type: this.GEO_AREAS_REQUEST
        }
    }

    static geoAreas_Success(data) {
        return {
            type: this.GEO_AREAS_SUCCESS,
            data
        }
    }

    static geoAreas_Failed(error) {
        return {
            type: this.GEO_AREAS_FAILED,
            error
        }
    }

    // PRODUCT BRANDS

    static GEO_TOWNS_REQUEST = 'GEO_TOWNS_REQUEST';
    static GEO_TOWNS_SUCCESS = 'GEO_TOWNS_SUCCESS';
    static GEO_TOWNS_FAILED = 'GEO_TOWNS_FAILED';

    static geoTowns_Request() {
        return {
            type: this.GEO_TOWNS_REQUEST
        }
    }

    static geoTowns_Success(data) {
        return {
            type: this.GEO_TOWNS_SUCCESS,
            data
        }
    }

    static geoTowns_Failed(error) {
        return {
            type: this.GEO_TOWNS_FAILED,
            error
        }
    }

    // GEO DISTRIBUTORS

    static GEO_DISTRIBUTORS_REQUEST = 'GEO_DISTRIBUTORS_REQUEST';
    static GEO_DISTRIBUTORS_SUCCESS = 'GEO_DISTRIBUTORS_SUCCESS';
    static GEO_DISTRIBUTORS_FAILED = 'GEO_DISTRIBUTORS_FAILED';

    static geoDistributors_Request() {
        return {
            type: this.GEO_DISTRIBUTORS_REQUEST
        }
    }

    static geoDistributors_Success(data) {
        return {
            type: this.GEO_DISTRIBUTORS_SUCCESS,
            data
        }
    }

    static geoDistributors_Failed(error) {
        return {
            type: this.GEO_DISTRIBUTORS_FAILED,
            error
        }
    }

    // direct customer
    static DIRECT_CUSTOMER_REQUEST = 'DIRECT_CUSTOMER_REQUEST';
    static DIRECT_CUSTOMER_SUCCESS = 'DIRECT_CUSTOMER_SUCCESS';
    static DIRECT_CUSTOMER_FAILED = 'DIRECT_CUSTOMER_FAILED';

    static geoDirectcustomer_Request() {
        return {
            type: this.DIRECT_CUSTOMER_REQUEST
        }
    }

    static geoDirectcustomer_Success(data) {
        return {
            type: this.DIRECT_CUSTOMER_SUCCESS,
            data
        }
    }

    static geoDirectcustomer_Failed(error) {
        return {
            type: this.DIRECT_CUSTOMER_FAILED,
            error
        }
    }

    //GEO DISTRIBUTORS ON SELECTED RESGIONS
    static GEO_DISTRIBUTORS_ON_RESGIONS_REQUEST = 'GEO_DISTRIBUTORS_ON_RESGIONS_REQUEST';
    static GEO_DISTRIBUTORS_ON_RESGIONS_SUCCESS = 'GEO_DISTRIBUTORS_ON_RESGIONS_SUCCESS';
    static GEO_DISTRIBUTORS_ON_RESGIONS_FAILED = 'GEO_DISTRIBUTORS_ON_RESGIONS_FAILED';

    static geoDistributors_on_resgion_Request() {
        return {
            type: this.GEO_DISTRIBUTORS_ON_RESGIONS_REQUEST
        }
    }

    static geoDistributors_on_resgion_Success(data) {
        return {
            type: this.GEO_DISTRIBUTORS_ON_RESGIONS_SUCCESS,
            data
        }
    }

    static geoDistributors_on_resgion_Failed(error) {
        return {
            type: this.GEO_DISTRIBUTORS_ON_RESGIONS_FAILED,
            error
        }
    }

}